<p-toast></p-toast>
<app-layout-category></app-layout-category>
<div class="home-page">
    <div class="breadcrumb-container mt-3 page">
        <div class="highlights">
            <a [routerLink]="['/']">{{'home' | translate}}</a>
            >
            <a [routerLink]="['/category',dealCategory?.category_safe_name]">{{dealCategory?.category_name}}</a>
        </div>
        <div class="text-center my-8" [hidden]="!loading">
            <p-progressSpinner></p-progressSpinner>
        </div>
        <div class="my-3 py-4 px-2 md:px-6 bg-white border-round">
            <div class="grid">
                <div class="col-12 sm:col-4 text-center align-self-center">
                    <img class="deal-detail-image"
                         src="{{deal.file_name | dealimageurl}}"
                         [appImgFallback]="dealImageFallback"
                         [ngClass]="{'deal-expired': isExpired}">
                </div>
                <div class="col-12 sm:col-8">
                    <div class="grid">
                        <div class="col-12" [ngClass]="{'deal-expired': isExpired}">
                            <h1>{{ deal.link_title | replacespaces }}</h1>
                        </div>
                        <div class="col" [ngClass]="{'deal-expired': isExpired}">
                            <app-deal-meta [deal]="deal"></app-deal-meta>
                        </div>
                        <div class="col flex flex-column justify-content-end">
                            <div class="justify-content-end mb-3 align-self-end" [ngClass]="{'deal-expired': isExpired}">
                                <div class="flex deal-meta-button" style="max-width: 150px">
                                    <a class="deal-flat-button p-2 icon-disliked" *ngIf="deal.link_votes < 0 && isExpired"></a>
                                    <a class="deal-flat-button p-2 icon-liked" *ngIf="deal.link_votes >= 0 && isExpired"></a>
                                    <div class="mr-2" *ngIf="isExpired">{{deal.link_votes}}&nbsp;{{'expired' | translate}}</div>
                                    <a class="deal-flat-button p-2 icon-disliked" (click)="voteRemovePress(-10)" *ngIf="deal.vote_value === -10 && !isExpired"></a>
                                    <a class="deal-flat-button p-2 icon-dislike" (click)="votePress(-10)" *ngIf="deal.vote_value !== -10 && !isExpired"></a>
                                    <div class="text-center" style="min-width: 2rem;" *ngIf="!isExpired">{{deal.link_votes}}</div>
                                    <a class="deal-flat-button p-2 icon-liked" (click)="voteRemovePress(10)"  *ngIf="deal.vote_value === 10 && !isExpired"></a>
                                    <a class="deal-flat-button p-2 icon-like" (click)="votePress(10)"  *ngIf="deal.vote_value !== 10 && !isExpired"></a>
                                </div>
                            </div>
                            <div class="flex flex-row justify-content-end align-content-center">
                                <button type="button"
                                        class="h-full w-3rem p-button-raised p-button-black"
                                        pButton
                                        icon="pi pi-cog"(click)="menu.toggle($event)"></button>
                                <p-menu #menu [popup]="true" [model]="items"></p-menu>
                                <div class="w-1rem"></div>
                                <p-button label="{{'go_to_deal_btn' | translate}}"
                                          icon="pi icon-cart"
                                          styleClass="p-button-dlnd p-button-raised"
                                          iconPos="right"
                                          [ngClass]="{'deal-expired': isExpired}"
                                          (click)="goToUrl()"></p-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <div class="mt-5 text-xl font-semibold" *ngIf="deal.link_promo_code !== '' && deal.link_promo_code !== undefined && deal.link_promo_code !== null">{{'promo_code' | translate}}</div>
            <div class="mt-3 -mb-3 text-center border-dashed border-orange-500 col-12"
                 *ngIf="deal.link_promo_code !== '' && deal.link_promo_code !== undefined && deal.link_promo_code !== null"
                (click)="copyPromoCode()">{{deal.link_promo_code}}</div>
            <div class="mt-5 text-xl font-semibold">{{'description' | translate}}</div>
            <div class="col-12" [innerHtml]="dealSafeContent"></div>
            <hr/>
            <p-carousel [value]="deal.relatedDeals"
                        [circular]="true"
                        [numVisible]="5"
                        [numScroll]="3"
                        contentClass="deal-details"
                        [responsiveOptions]="carouselRespOpt">
                <ng-template pTemplate="header">
                    <h5 class="text-xl">{{'deal_related' | translate}}</h5>
                </ng-template>
                <ng-template let-deal pTemplate="item">
                    <app-deal-detail-related  [deal]="deal"></app-deal-detail-related>
                </ng-template>
            </p-carousel>
            <hr/>
            <h5 class="text-xl" id="comments">{{deal.link_comments}}&nbsp;Comments</h5>
            <div class="row">
                <div class="col-xs-12 col-md-8 offset-md-2">
                    <app-deal-comment
                            *ngFor="let comment of comments"
                            [comment]="comment"
                            (deleteComment)="onDeleteComment(comment)"
                            (editComment)="onEditComment(comment)">
                    </app-deal-comment>
                    <p-paginator *ngIf="needCommentPaginator"
                                 [rows]="commentsPerPage"
                                 [totalRecords]="numberOfComments"
                                 (onPageChange)="commentPageChanged($event)">
                    </p-paginator>

                    <div *appShowAuthed="true">
                        <p-editor [(ngModel)]="newCommentContent"
                                  [style]="{'height':'150px'}"
                                  placeholder="{{'add_comment_placeholder' | translate}}">
                            <ng-template pTemplate="header">
        <span class="ql-formats">
            <button type="button" class="ql-bold" aria-label="Bold"></button>
            <button type="button" class="ql-italic" aria-label="Italic"></button>
            <button type="button" class="ql-underline" aria-label="Underline"></button>
        </span>
                            </ng-template>
                        </p-editor>
                        <div class="flex justify-content-end">
                            <button pButton label="{{'send_comment_btn' | translate}}"
                                    type="button"
                                    class="p-button-raised p-button-dlnd mt-2 flex-grow-1 md:flex-grow-0"
                                    (click)="addComment()"
                                    [disabled]="newCommentContent == ''"
                                    [loading]="isSubmitting">
                            </button>
                        </div>
                    </div>

                    <div *appShowAuthed="false">
                        <a class="cursor-pointer font-medium" (click)="needLogin()"> {{'login' | translate}}</a>&nbsp;{{'or' | translate}}&nbsp;<a class="cursor-pointer font-medium"  (click)="needLogin(true)">{{'signup' | translate}}</a>&nbsp;{{'to_comment'|translate}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<p-confirmDialog [style]="{width: '50vw'}"
                 [baseZIndex]="10000"
                 acceptButtonStyleClass="p-button-dlnd-dark"
                 rejectButtonStyleClass="p-button-dlnd"></p-confirmDialog>
